import React, { useEffect } from "react";
import { authenticationService } from '../../services/authenticationService';

const Logout = ({history}) => {
    useEffect(() => {
        if (authenticationService.currentUserValue) {
            authenticationService.logout()
        } else {
            history.push("/login");
        }
    }, [history]);

    return (<>
        <div className="text-center text-light">
            <div className="fa-3x">
                <i className="fas fa-spinner fa-spin"></i>
            </div>
            <p className="mt-3">
                Logging you out...
            </p>
        </div>
    </>
    )
}
export default Logout;